var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input-group flex-nowrap" }, [
    _c("div", { staticClass: "input-group-prepend" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-outline-secondary btn-sm",
          attrs: {
            type: "button",
            disabled: _vm.isDisabled || _vm.inputValue <= _vm.min
          },
          on: { click: _vm.handleMinus }
        },
        [_vm._v("-")]
      )
    ]),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model.number",
          value: _vm.inputValue,
          expression: "inputValue",
          modifiers: { number: true }
        }
      ],
      ref: "input",
      staticClass: "product-amount-field form-control form-control-sm",
      class: { "is-invalid": _vm.isInvalid, disabled: _vm.isDisabled },
      attrs: {
        type: "number",
        min: Number(_vm.min),
        max: Number(_vm.max),
        step: Number(_vm.step),
        disabled: _vm.isDisabled,
        tabindex: "2"
      },
      domProps: { value: _vm.inputValue },
      on: {
        input: [
          function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.inputValue = _vm._n($event.target.value)
          },
          _vm.handleInput
        ],
        change: _vm.handleChange,
        blur: function($event) {
          return _vm.$forceUpdate()
        }
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "input-group-append" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-outline-secondary btn-sm",
          attrs: {
            type: "button",
            disabled: _vm.isDisabled || _vm.inputValue >= _vm.max
          },
          on: { click: _vm.handlePlus }
        },
        [_vm._v("+")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }